"use client";

import { create } from "zustand";

type UiStore = {
  sidebarOpen: boolean;
  setSidebarOpen: (value: boolean) => void;
  artifactsEnabled: boolean;
  setArtifactsEnabled: (value: boolean) => void;
  artifactCountsBySession: Record<string, number>;
  setSessionArtifactCount: (sessionId: string, count: number) => void;
};

export const useUiStore = create<UiStore>((set) => ({
  sidebarOpen: true,
  setSidebarOpen: (value) => set({ sidebarOpen: value }),
  artifactsEnabled: false,
  setArtifactsEnabled: (value) => set({ artifactsEnabled: value }),
  artifactCountsBySession: {},
  setSessionArtifactCount: (sessionId, count) =>
    set((state) => {
      const nextCount = Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0;
      const currentCount = state.artifactCountsBySession[sessionId] ?? 0;
      if (currentCount === nextCount) return state;
      return {
        artifactCountsBySession: {
          ...state.artifactCountsBySession,
          [sessionId]: nextCount
        }
      };
    })
}));
